@if (houseConsignment) {
  <app-consignment-details-alerts></app-consignment-details-alerts>
  <div class="modal-header">
    <div class="flex-container align-items-center">
      <button type="button" class="btn-close me-2 d-inline-flex" data-bs-dismiss="modal" aria-label="Close"></button>
      <div class="d-inline-flex me-1">
        <i class="fa fa-fw fa-light fa-lg fa-file-lines text-muted"></i>
      </div>
      <button class="btn btn-link p-0 page-title align-baseline" (click)="processModelAndOpenMasterConsignment()">
        <span class="page-title">{{ consignmentProcess.consignmentMasterLevel.consignmentNumber }}</span>
      </button>
      @if (consignmentProcess.cancelled) {
        <app-tooltip placement="bottom" class="ms-2">
          <span class="fa text-danger fa-fw fa-ban"></span>
          <span class="tooltipContent">Cancelled</span>
        </app-tooltip>
      }
      <div class="d-inline-flex mx-2">
        <i class="fa fa-fw fa-light fa-lg fa-chevron-right text-muted"></i>
      </div>
      <div class="d-inline-flex me-1">
        <i class="fa fa-kit fa-fw fa-light fa-lg fa-pb-file-line text-muted"></i>
      </div>
      <span class="page-title">{{ houseConsignment.consignmentNumber }}</span>
    </div>
  </div>
  <div class="modal-body p-0">
    <app-tab-panel [sticky]="true" [alwaysRender]="true" (tabChange)="onTabChange($event)">
      <app-tab-item [templateRef]="detailsRef">
        <span class="tab-item">Details</span>
        <ng-template #detailsRef>
          <div class="container py-3">
            <div class="card">
              <div class="card-body p-5">
                @if (editMode && allowedToCopy) {
                  <div class="position-absolute top-0 end-0 mt-4 me-5">
                    <button type="button" class="btn btn-outline-secondary" (click)="tryCopyFromMaster()">
                      Copy from master B/L
                    </button>
                  </div>
                }
                <div class="row gy-4 my-0">
                  <h5 class="h1 col-12 m-0">House bill of lading details</h5>
                  <div class="col-12">
                    <div class="row gy-4">
                      <app-form-field label="House bill of lading number" class="col-12 col-md-6"
                                      [(value)]="houseConsignment.consignmentNumber"
                                      [includeMargin]="false" [editMode]="editMode" [renderOptional]="false">
                        @if (isNewConsignment) {
                          <input class="input-group form-control"
                                 (change)="houseConsignment.consignmentNumber=$event.target.value.toUpperCase()"
                                 [(ngModel)]="houseConsignment.consignmentNumber" required/>
                        } @else {
                          <span>{{ houseConsignment.consignmentNumber }}</span>
                        }
                        <ng-template #blAsLabel>
                          <span>{{ houseConsignment.consignmentNumber }}</span>
                        </ng-template>
                      </app-form-field>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row gy-4">
                      <app-form-field label="Trader assigned reference" class="col-6 col-md-4"
                                      [(value)]="houseConsignment.traderAssignedReference" [editMode]="editMode"
                                      [includeMargin]="false"
                                      [checkForErrors]="true">
                        <input class="input-group form-control"
                               [(ngModel)]="houseConsignment.traderAssignedReference"/>
                      </app-form-field>
                    </div>
                  </div>
                  @if (editMode) {
                    <div class="col-12">
                      <div class="row gy-4">
                        <app-form-field label="Place of acceptance" class="col-6 col-md-4"
                                        [(value)]="houseConsignment.placeOfAcceptance" [editMode]="editMode"
                                        [includeMargin]="false" [formatter]="utils.placeFormatter"
                                        tooltip="The location where the goods are taken over from the consignor"
                                        [checkForErrors]="true">
                          <app-search [(ngModel)]="houseConsignment.placeOfAcceptance"
                                      [inputFormatter]="refData.locationFormatter" (ngModelChange)="updateRoutes()"
                                      [required]="rules.ensFilingRequired(consignmentProcess.filing.filingType)"
                                      [searchFunction]="refData.findLocation"></app-search>
                        </app-form-field>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row gy-4">
                        <app-form-field label="Place of delivery" class="col-6 col-md-4"
                                        [(value)]="houseConsignment.placeOfDelivery" [editMode]="editMode"
                                        [includeMargin]="false" [formatter]="utils.placeFormatter"
                                        tooltip="The location at which the goods are to be received by the consignee"
                                        [checkForErrors]="true">
                          <app-search [(ngModel)]="houseConsignment.placeOfDelivery"
                                      [inputFormatter]="refData.locationFormatter" (ngModelChange)="updateRoutes()"
                                      [required]="!rules.isTemporaryStorageOnlyConsignment(consignmentProcess.filing.filingType)"
                                      [searchFunction]="refData.findLocation"></app-search>
                        </app-form-field>
                      </div>
                    </div>
                  }
                  @if (!editMode || !consignmentProcess.filing.crn) {
                    <div class="col-12">
                      <span class="d-block fw-regular mb-3">Route</span>
                      @if (editMode) {
                        <p>A minimum of 2 countries is required, one of which must be a member of the
                          European Union.</p>
                      }
                      <div class="consignment-routes row gy-4">
                        @for (route of routes; track route; let i = $index) {
                          <div class="col-12">
                            <app-master-consignment-route [routeInfo]="route" [index]="i" [editMode]="editMode"
                                                          [(allRoutes)]="routes"></app-master-consignment-route>
                          </div>
                        }
                      </div>
                      @if (editMode) {
                        <div class="row mt-3">
                          <div class="col-auto">
                            <button class="btn btn-outline-primary text-decoration-none" (click)="addRoute()">
                              <i class="fa-lg fa-light fa-plus"></i>
                              <span class="ps-2 d-none d-md-inline">Add country</span>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (houseConsignment.transportCharges) {
                    <div class="col-12">
                      <div class="row">
                        <app-form-field label="Payment method" class="col col-md-6"
                                        [(value)]="houseConsignment.transportCharges.methodOfPayment"
                                        [editMode]="editMode" [includeMargin]="false"
                                        [formatter]="utils.methodOfPaymentFormatter">
                          <app-search [(ngModel)]="houseConsignment.transportCharges.methodOfPayment"
                                      [options]="utils.methodsOfPayment" [required]="true"
                                      [inputFormatter]="utils.methodOfPaymentFormatter"></app-search>
                        </app-form-field>
                      </div>
                    </div>
                  }
                  @for (supportingDocument of houseConsignment.supportingDocuments; track $index) {
                    <div class="col-12">
                      <div class="row">
                        <app-form-field label="Supporting documents" class="col col-md-7" [truncateReadOnly]="true"
                                        [value]="supportingDocument.type" [editMode]="editMode"
                                        [includeMargin]="false" [formatter]="utils.documentTypeFormatter"
                                        [checkForErrors]="'Supporting document type'">
                          <app-search [(ngModel)]="supportingDocument.type"
                                      [inputFormatter]="utils.documentTypeFormatter"
                                      [searchFunction]="utils.findDocumentTypes"
                                      placeholder="Select a document type"></app-search>
                        </app-form-field>
                        <app-form-field label="Reference number" [value]="supportingDocument.referenceNumber"
                                        class="col col-md-3"
                                        [editMode]="editMode" [includeMargin]="false"
                                        [checkForErrors]="'Supporting document number'">
                          <input class="input-group form-control" required
                                 [(ngModel)]="supportingDocument.referenceNumber"/>
                        </app-form-field>
                        @if (editMode) {
                          <div class="col-auto d-flex align-items-center pt-5">
                            <button class="btn rounded-circle p-1 px-2 text-danger h1 mb-0"
                                    (click)="deleteSupportingDocument(supportingDocument)">
                              <i class="fa-light fa-trash-can"></i>
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <div class="col-12">
                    @if (editMode) {
                      <div class="row mt-3">
                        <div class="col-auto">
                          <button class="btn btn-outline-primary text-decoration-none"
                                  (click)="addSupportingDocument()">
                            <i class="fa-lg fa-light fa-plus"></i>
                            <span class="ps-2 d-none d-md-inline">Add supporting document</span>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </app-tab-item>
      <app-tab-item [templateRef]="supplyChainActorsRef">
        <span class="tab-item">
          <span errorIndicator [predicate]="partyPredicate" [overrideRef]="elementRef"></span>
          Parties
        </span>
        <ng-template #supplyChainActorsRef>
          <div class="container py-3">
            <div class="card">
              <div class="card-body p-5">
                <div class="row gy-4 my-0">
                  <h5 class="h1 col-12 m-0">Supply chain actors</h5>
                  <div class="col-12">
                    <app-consignment-party-details [(party)]="houseConsignment.consignee" [editMode]="editMode"
                                                   [cargoDeclarantId]="consignmentProcess.filing.declarant.iamConnectedId"
                                                   [filingType]="consignmentProcess.filing.filingType"
                                                   label="Consignee"></app-consignment-party-details>
                  </div>
                  <div class="col-12">
                    <app-consignment-party-details [(party)]="houseConsignment.consignor" [editMode]="editMode"
                                                   [cargoDeclarantId]="consignmentProcess.filing.declarant.iamConnectedId"
                                                   [required]="true" [filingType]="consignmentProcess.filing.filingType"
                                                   label="Consignor"></app-consignment-party-details>
                  </div>
                  @if (consignmentProcess.filing.filingType === 'F13') {
                    <div class="col-12">
                      <app-consignment-supplementary-declarant
                        [(supplementaryDeclarant)]="houseConsignment.supplementaryDeclarant"
                        [supplementaryFilingType]="'N2'"
                        [editMode]="editMode" [required]="true"
                        label="Supplementary declarant"></app-consignment-supplementary-declarant>
                    </div>
                  }
                  @if (houseConsignment.goodsShipment &&
                  rules.isSingleFilingConsignmentOrRoad(consignmentProcess)) {
                    <div class="col-12">
                      <app-consignment-party-details [(party)]="houseConsignment.goodsShipment.buyer"
                                                     [editMode]="editMode"
                                                     [cargoDeclarantId]="consignmentProcess.filing.declarant.iamConnectedId"
                                                     [required]="rules.isEuPort(houseConsignment.placeOfDelivery)"
                                                     label="Buyer"
                                                     tooltip="The buyer is the last known entity to whom the goods are sold or agreed to be sold. If the goods are to be imported otherwise than in pursuance of a purchase, the details of the owner of the goods shall be provided"></app-consignment-party-details>
                    </div>
                    <div class="col-12">
                      <app-consignment-party-details [(party)]="houseConsignment.goodsShipment.seller"
                                                     [editMode]="editMode"
                                                     [cargoDeclarantId]="consignmentProcess.filing.declarant.iamConnectedId"
                                                     [required]="rules.isEuPort(houseConsignment.placeOfDelivery)"
                                                     label="Seller"
                                                     tooltip="The seller is the last known entity by whom the goods are sold or agreed to be sold to the buyer. If the goods are to be imported otherwise than in pursuance of a purchase, the details of the owner of the goods shall be provided."></app-consignment-party-details>
                    </div>
                  }
                </div>
                @if (houseConsignment.notifyParties?.length || editMode) {
                  <div class="row gy-4 my-5">
                    <h5 class="h1 col-12 m-0">Notify parties</h5>
                    @for (party of houseConsignment.notifyParties; track $index; let i = $index) {
                      <div class="col-12">
                        <app-consignment-party-details
                          [(party)]="houseConsignment.notifyParties[i]" (partyChange)="checkPartyDeletion($event, i)"
                          [cargoDeclarantId]="consignmentProcess.filing.declarant.iamConnectedId"
                          [editMode]="editMode" [required]="true" [deletionAllowed]="true"
                          [communicationRequired]="true" [filingType]="consignmentProcess.filing.filingType"
                          [label]="party.name || 'Notify party'"></app-consignment-party-details>
                      </div>
                    }
                    @if (editMode) {
                      <div class="col-12">
                        <div class="col-auto">
                          <button type="button" class="btn btn-outline-primary" (click)="addNotifyParty()">
                            <i class="fa-lg fa fa-fw fa-plus"></i>
                            Add notify party
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                }
                <div class="row gy-4 my-5">
                  @if (houseConsignment.additionalSupplyChainActors?.length || editMode) {
                    <h5 class="h1 col-12 m-0">Supply chain actors</h5>
                    @for (supplyChainActor of houseConsignment.additionalSupplyChainActors; track $index) {
                      <div class="col-12">
                        <app-additional-supply-chain-actor-details [consignmentProcess]="consignmentProcess"
                                                                   [supplyChainActor]="supplyChainActor"
                                                                   [editMode]="editMode"
                                                                   (supplyChainActorChange)="checkSupplyChainActorDeletion($event, $index)"
                                                                   [label]="utils.supplyChainTypeFormatter(supplyChainActor.type)"></app-additional-supply-chain-actor-details>
                      </div>
                    }
                    @if (editMode) {
                      <div class="col-12">
                        <div class="col-auto dropdown">
                          <button type="button" class="btn btn-outline-primary" data-bs-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false">
                            <i class="fa-lg fa fa-fw fa-plus"></i>
                            Add actor
                          </button>
                          <div class="dropdown-menu">
                            @for (type of utils.additionalSupplyChainTypes; track $index) {
                              <button class="btn dropdown-item" (click)="addSupplyChainActor(type)">
                                {{ utils.supplyChainTypeFormatter(type) }}
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </app-tab-item>
      <app-tab-item [templateRef]="goodsRef">
        <span class="tab-item">
          <span errorIndicator [predicate]="goodsItemPredicate" [overrideRef]="elementRef"></span>
          <span>Goods</span>
          <span class="ps-2 fw-light">{{ goodsItems?.length }}</span>
        </span>
        <ng-template #goodsRef>
          <app-consignment-goods-table [data]="goodsItems" [editable]="isEditable"
                                       [consignmentProcess]="consignmentProcess"
                                       [houseConsignment]="houseConsignment"
                                       [errorGoodsItemNumbers]="errorGoodsItemNumbers"></app-consignment-goods-table>
        </ng-template>
      </app-tab-item>
      <app-tab-item [templateRef]="equipmentRef">
        <span class="tab-item">
          <span errorIndicator [predicate]="equipmentPredicate" [overrideRef]="elementRef"></span>
          <span>Equipment</span>
          <span class="ps-2 fw-light">{{ equipmentListSummaries?.length }}</span>
        </span>
        <ng-template #equipmentRef>
          <app-consignment-equipments-table [data]="equipmentListSummaries" [editable]="isEditable"
                                            [houseConsignmentNumber]="houseConsignment.consignmentNumber"
                                            [errorEquipmentNumbers]="errorEquipmentNumbers"></app-consignment-equipments-table>
        </ng-template>
      </app-tab-item>
      @if (canHavePassiveBorderTransportMeans()) {
        <app-tab-item [templateRef]="vehiclesRef">
          <span class="tab-item">Vehicles</span>
          <ng-template #vehiclesRef>
            <app-consignment-vehicles-table [(data)]="houseConsignment.passiveBorderTransportMeans"
                                            [editable]="isEditable"
                                            [(editMode)]="editMode"></app-consignment-vehicles-table>
          </ng-template>
        </app-tab-item>
      }
    </app-tab-panel>
  </div>
  @if (!consignmentProcess.fromVisit) {
    <div class="modal-footer">
      <div class="d-flex flex-grow-1">
        <div class="container">
          <div class="row mx-4">
            <div class="col-auto">
              <button type="button" class="btn btn-outline-danger" (click)="remove()">Remove</button>
            </div>
            <div class="col-auto ms-auto">
              @if (!editMode) {
                <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close"
                >
                  Close
                </button>
              }
              @if (editMode) {
                <button type="button" class="btn btn-outline-secondary" (click)="toggleEdit()">
                  Cancel
                </button>
              }
            </div>
            <div class="col-auto">
              @if (editMode) {
                @if (hasBeenDeclared) {
                  <button type="button" class="btn btn-primary" (click)="toggleEdit()">
                    Ok
                  </button>
                }
                @if (!hasBeenDeclared) {
                  <button type="button" class="btn btn-primary" (click)="saveOrDeclare()">
                    Save
                  </button>
                }
              } @else {
                @if (isEditableForTab) {
                  <button type="button" class="btn btn-outline-secondary me-4" (click)="toggleEdit()">
                    Edit
                  </button>
                }
                @if (allowedToDeclare && hasBeenDeclared) {
                  <button type="button" class="btn btn-primary" (click)="saveOrDeclare()">
                    {{consignmentProcess?.cancelled ? "Re-open" : "Update"}}
                  </button>
                }
              }
              <ng-template #readMode>
                @if (isEditableForTab) {
                  <button type="button" class="btn btn-outline-secondary me-4" (click)="toggleEdit()">
                    Edit
                  </button>
                }
                @if (allowedToDeclare && hasBeenDeclared) {
                  <button type="button" class="btn btn-primary" (click)="saveOrDeclare()">
                    {{consignmentProcess?.cancelled ? "Re-open" : "Update"}}
                  </button>
                }
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

<div class="w-100 h-100 position-absolute d-flex flex-column-reverse" [ngClass]="showSubModal ? '' : 'd-none'">
  <div class="w-100 h-100 position-absolute modal-backdrop show" (click)="closeConsignmentSubModal()"></div>
  <div class="bg-body" style="z-index: 1050; height: calc(100% - 110px);">
    <ng-template #subModalContainer></ng-template>
  </div>
</div>
